// extracted by mini-css-extract-plugin
export default {"wrapper":"FavoriteIcon__wrapper--1Ub","actuator":"FavoriteIcon__actuator--2Oq","icon":"FavoriteIcon__icon--XnH","featured":"FavoriteIcon__featured--LUl","on":"FavoriteIcon__on--1Ta"};